import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Images } from 'assets/images';
import { ImageLazy } from 'components/ImageLazy';
import { LazyContainer } from 'components/ImageLazy/styled';
import { offersAction, questionsActions } from 'store';
import { ButtonsContent, QuestionsContent, StepperContent } from './fragments';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'utils/routeNames';
import { Container, StyledContent, StyledQuestionsPage } from './styled';

export const Questions = () => {
  const { questions } = useSelector((state) => state.questions);
  const { offers } = useSelector((state) => state.offersReducer);
  const [activeStep, setActiveStep] = useState(1);

  const [skipped, setSkipped] = useState(new Set());
  const [isChooseAnswer, setIsChooseAnswer] = useState(true);
  const [answers, setAnswers] = useState([]);
  const [answerItem, setAnswerItem] = useState({});

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isStepSkipped = (step) => skipped.has(step);

  useEffect(() => {
    if (
      Object.keys(answerItem).length !== 0 &&
      answerItem?.selectedAnswers?.length !== 0
    ) {
      setIsChooseAnswer(false);
    } else {
      setIsChooseAnswer(true);
    }
  }, [answerItem]);

  useEffect(() => {
    dispatch(offersAction.getOffers());
    dispatch(questionsActions.getQuestions());
  }, []);

  useEffect(() => {
    if (offers?.length >= 3) {
      navigate(ROUTES.WELCOME);
    }
  }, [offers?.length]);

  return (
    <StyledQuestionsPage>
      <LazyContainer>
        <ImageLazy
          src={Images.settingsBackgroundOrigin}
          width="100%"
          height="100%"
          hash="LzGml3Aui]WC_LJVjWWXohniW-j]"
        />
      </LazyContainer>
      <StyledContent>
        <Container>
          <StepperContent
            isStepSkipped={isStepSkipped}
            activeStep={activeStep}
            questions={questions}
          />

          <QuestionsContent
            setAnswerItem={setAnswerItem}
            answers={answers}
            isStepSkipped={isStepSkipped}
            setAnswers={setAnswers}
            setIsChooseAnswer={setIsChooseAnswer}
            activeStep={activeStep}
            answerItem={answerItem}
            questions={questions}
          />
        </Container>

        <ButtonsContent
          activeStep={activeStep}
          answers={answers}
          questions={questions}
          isChooseAnswer={isChooseAnswer}
          skipped={skipped}
          isStepSkipped={isStepSkipped}
          setAnswerItem={setAnswerItem}
          setIsChooseAnswer={setIsChooseAnswer}
          setActiveStep={setActiveStep}
          setSkipped={setSkipped}
        />
      </StyledContent>
    </StyledQuestionsPage>
  );
};
